export const play = (
  <path
    d="M8 22.5V5.5L22.5 14L8 22.5Z"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinejoin="bevel"
  />
);

export const playFill = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.50572 4.6373L7 5.5V22.5L8.50572 23.3627L23.0057 14.8627V13.1373L8.50572 4.6373Z"
    fill="currentColor"
  />
);

export const pause = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9 5V23H11V5H9ZM17 5V23H19V5H17Z"
    fill="currentColor"
  />
);

export const pauseFill = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M11.4 5H8.1L7 6V22L8.1 23H11.4L12.5 22V6L11.4 5ZM19.9 5H16.6L15.5 6V22L16.6 23H19.9L21 22V6L19.9 5Z"
    fill="currentColor"
  />
);

export const stop = (
  <path
    d="M6 22V6H22V22H6Z"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinejoin="bevel"
  />
);

export const stopFill = (
  <path d="M6 5L5 6V22L6 23H22L23 22V6L22 5H6Z" fill="currentColor" />
);

export const power = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13 2.5V13.5H15V2.5H13ZM8.67361 7.05732C6.58996 8.65855 5.25 11.1726 5.25 14C5.25 18.8325 9.16751 22.75 14 22.75C18.8325 22.75 22.75 18.8325 22.75 14C22.75 11.1726 21.41 8.65855 19.3264 7.05732L20.5451 5.47149C23.1001 7.43498 24.75 10.525 24.75 14C24.75 19.937 19.9371 24.75 14 24.75C8.06294 24.75 3.25 19.937 3.25 14C3.25 10.525 4.8999 7.43498 7.45495 5.47149L8.67361 7.05732Z"
    fill="currentColor"
  />
);

export const move = (
  <path
    d="M17.9387 21.4534C16.9968 22.186 16.1511 23.0304 15.5374 23.6975C15.2318 24.0297 14.9869 24.3156 14.8186 24.5169C14.7346 24.6173 14.6693 24.6967 14.6262 24.7503C14.6049 24.7768 14.5888 24.7976 14.5784 24.8108C14.5734 24.8171 14.569 24.8215 14.5667 24.8245C14.5656 24.8259 14.5651 24.8277 14.5647 24.8284H13.4358C13.4353 24.8278 13.435 24.826 13.4338 24.8245C13.4315 24.8215 13.4271 24.8172 13.4221 24.8108C13.4117 24.7976 13.3957 24.7769 13.3743 24.7503C13.3312 24.6967 13.2659 24.6174 13.1819 24.5169C13.0136 24.3157 12.7687 24.0297 12.4631 23.6975C11.8494 23.0304 11.0037 22.1861 10.0618 21.4534L10.9387 20.3264C11.9653 21.1249 12.8699 22.0308 13.5139 22.7307C13.6975 22.9303 13.8604 23.1146 14.0002 23.2757C14.1401 23.1146 14.3031 22.9302 14.4866 22.7307C15.1306 22.0307 16.0352 21.1249 17.0618 20.3264L17.9387 21.4534ZM7.6731 10.9388C6.87464 11.9653 5.96874 12.87 5.2688 13.5139C5.06938 13.6974 4.8849 13.8605 4.72388 14.0003C4.88498 14.1402 5.06927 14.303 5.2688 14.4866C5.96882 15.1306 6.87457 16.0351 7.6731 17.0618L6.54614 17.9388C5.81345 16.9967 4.96913 16.1511 4.302 15.5374C3.96979 15.2318 3.6839 14.9869 3.48267 14.8186C3.38215 14.7346 3.30283 14.6693 3.24927 14.6263C3.22263 14.6048 3.20193 14.5888 3.18872 14.5784C3.18237 14.5734 3.17805 14.569 3.17505 14.5667C3.17355 14.5655 3.17172 14.5652 3.17114 14.5647V13.4358C3.17168 13.4354 3.17362 13.4348 3.17505 13.4339C3.17801 13.4315 3.18253 13.4271 3.18872 13.4221C3.20189 13.4117 3.22276 13.3956 3.24927 13.3743C3.30278 13.3312 3.38228 13.2658 3.48267 13.1819C3.68384 13.0137 3.96992 12.7687 4.302 12.4632C4.96905 11.8495 5.81351 11.0037 6.54614 10.0618L7.6731 10.9388ZM21.4534 10.0618C22.186 11.0038 23.0304 11.8494 23.6975 12.4632C24.0297 12.7688 24.3156 13.0137 24.5168 13.1819C24.6174 13.2659 24.6967 13.3312 24.7502 13.3743C24.7769 13.3957 24.7976 13.4117 24.8108 13.4221C24.8171 13.4272 24.8215 13.4315 24.8245 13.4339C24.826 13.435 24.8278 13.4354 24.8284 13.4358V14.5647C24.8276 14.5651 24.8258 14.5656 24.8245 14.5667C24.8215 14.5691 24.817 14.5735 24.8108 14.5784C24.7976 14.5889 24.7768 14.6049 24.7502 14.6263C24.6967 14.6694 24.6173 14.7347 24.5168 14.8186C24.3156 14.9869 24.0296 15.2318 23.6975 15.5374C23.0304 16.1511 22.186 16.9968 21.4534 17.9388L20.3264 17.0618C21.1249 16.0352 22.0307 15.1306 22.7307 14.4866C22.9302 14.3031 23.1146 14.1401 23.2756 14.0003C23.1145 13.8604 22.9302 13.6975 22.7307 13.5139C22.0307 12.87 21.1249 11.9653 20.3264 10.9388L21.4534 10.0618ZM14.0002 10.5003C15.9331 10.5004 17.5002 12.0674 17.5002 14.0003C17.5001 15.933 15.933 17.5001 14.0002 17.5003C12.0673 17.5003 10.5004 15.9331 10.5002 14.0003C10.5002 12.0673 12.0672 10.5003 14.0002 10.5003ZM14.5667 3.17508C14.569 3.17808 14.5734 3.18241 14.5784 3.18875C14.5888 3.20196 14.6048 3.22266 14.6262 3.2493C14.6693 3.30286 14.7346 3.38218 14.8186 3.4827C14.9868 3.68393 15.2317 3.96983 15.5374 4.30203C16.1511 4.96916 16.9967 5.81348 17.9387 6.54617L17.0618 7.67313C16.0351 6.8746 15.1306 5.96885 14.4866 5.26883C14.303 5.0693 14.1401 4.88501 14.0002 4.72391C13.8604 4.88494 13.6974 5.0694 13.5139 5.26883C12.87 5.96878 11.9652 6.87466 10.9387 7.67313L10.0618 6.54617C11.0037 5.81354 11.8494 4.96909 12.4631 4.30203C12.7687 3.96994 13.0137 3.68388 13.1819 3.4827C13.2658 3.3823 13.3312 3.30281 13.3743 3.2493C13.3956 3.22278 13.4117 3.20192 13.4221 3.18875C13.4271 3.18255 13.4315 3.17804 13.4338 3.17508C13.4348 3.17364 13.4354 3.17172 13.4358 3.17117H14.5647C14.5651 3.17175 14.5655 3.17359 14.5667 3.17508Z"
    fill="currentColor"
    fill-opacity="0.9"
  />
);
